
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 会社情報 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">会社情報</h3>
            <div className="space-y-2 text-gray-300">
              <p>〒100-0001</p>
              <p>東京都千代田区千代田1-1-1</p>
              <p>TEL: 03-1234-5678</p>
              <p>FAX: 03-1234-5679</p>
              <p>営業時間: 平日 9:00-18:00</p>
            </div>
          </div>

          {/* サービス */}
          <div>
            <h3 className="text-lg font-semibold mb-4">サービス</h3>
            <ul className="space-y-2 text-gray-300">
              <li>税務申告</li>
              <li>経理代行</li>
              <li>給与計算</li>
              <li>会社設立支援</li>
              <li>経営コンサルティング</li>
            </ul>
          </div>

          {/* お問い合わせ */}
          <div>
            <h3 className="text-lg font-semibold mb-4">お問い合わせ</h3>
            <div className="space-y-2 text-gray-300">
              <p>初回相談無料</p>
              <p>お気軽にご相談ください</p>
              <div className="flex space-x-4 mt-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-phone-line text-xl cursor-pointer hover:text-blue-400"></i>
                </div>
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-mail-line text-xl cursor-pointer hover:text-blue-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 税理士事務所. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-blue-400 cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}
